const obj = {
  /**
   * 公共数据接口地址配置
   */
  updateImg: "/updatImg", //图片上传接口
  /**
   * 模块接口地址配置
   */
  /*  商品模块 */
  goodsList: "/goodsList", //商品列表获取接口
  /*  登录接口 */
  gologin: "/base/system/user/login", //登录接口sysmgt/api/user/login

}
export default obj;
